import React from "react";
import { Star } from "@phosphor-icons/react";

export default function StarRating({ value = 0, size = 16, count, className = "" }) {
  const full = Math.round(value);
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`} data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          weight={i <= full ? "fill" : "regular"}
          className={i <= full ? "star-on" : "star-off"}
        />
      ))}
      {typeof count === "number" && (
        <span className="text-xs text-[var(--text-muted)] ml-1">
          {value ? value.toFixed(1) : "New"} {count > 0 ? `· ${count}` : ""}
        </span>
      )}
    </span>
  );
}
